<mat-dialog-content>
    <div id="sdk-container">
        <!-- SDK elements will be inserted within this div-->
   </div>
</mat-dialog-content>
